import {
  CustomerStatistics,
  CustomerStatisticsAction,
  CustomerStatisticsActions,
  CustomerStatisticsFulfillOrderPayload,
  CustomerStatisticsOrdersPayload,
  CustomerStatisticsShipmentsPayload,
  CustomerStatisticsStockPayload
} from '../model';
import { RequestPayload, ResponsePayload } from '../model/request';
import { filter } from 'lodash';

import { CustomerState, wrapStateWithCustomerNumber } from '../utils/url';
import createReducer from './createReducer';

export const customerStatistics = createReducer<CustomerState<CustomerStatistics>>({}, {
  [CustomerStatisticsActions.FETCH_STATISTICS_STOCK](
    state: CustomerState<CustomerStatistics>,
    action: CustomerStatisticsAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const payload = action.payload as RequestPayload;
      const isZoomedIn = payload.request.params.year && payload.request.params.month;
      return {
        ...(oldState || {}),
        articleIds: payload.request.params.articleIds,
        year: payload.request.params.year,
        month: payload.request.params.month,
        isZoomedIn,
      };
    }, state, undefined);
  },

  [CustomerStatisticsActions.FETCH_STATISTICS_STOCK_SUCCESS](
    state: CustomerState<CustomerStatistics>,
    action: CustomerStatisticsAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const payload = action.payload as ResponsePayload<CustomerStatisticsStockPayload & {
        min: string;
        max: string;
      }>;
      const { min, max, ...data } = payload.data;
      return {
        ...(oldState || {}),
        stock: data,
        minDate: min,
        maxDate: max,
      };
    }, state, undefined);
  },
  [CustomerStatisticsActions.FETCH_STATISTICS_ORDERS_SUCCESS](
    state: CustomerState<CustomerStatistics>,
    action: CustomerStatisticsAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const payload = action.payload as ResponsePayload<CustomerStatisticsOrdersPayload>;
      return {
        ...(oldState || {}),
        orders: payload.data,
      };
    }, state, undefined);
  },
  [CustomerStatisticsActions.FETCH_STATISTICS_SHIPMENTS_SUCCESS](
    state: CustomerState<CustomerStatistics>,
    action: CustomerStatisticsAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const payload = action.payload as ResponsePayload<CustomerStatisticsShipmentsPayload>;
      return {
        ...(oldState || {}),
        shipments: payload.data,
      };
    }, state, undefined);
  },
  [CustomerStatisticsActions.FULFILL_STATISTICS_ORDER_SUCCESS](
    state: CustomerState<CustomerStatistics>,
    action: CustomerStatisticsAction
  ) {
    return wrapStateWithCustomerNumber(oldState => {
      const payload = action.payload as ResponsePayload<CustomerStatisticsFulfillOrderPayload>;
      return {
        ...(oldState || {}),
        orders: filter(oldState?.orders, o => o.id !== payload.data.id),
      };
    }, state, undefined);
  },
});
